// Flatten the visible category catalog without duplicating nodes or following cycles.
export function directoryCategoryOptions(categories) {
  const byId = new Map(categories.map(category => [category.id, category]));
  const seen = new Set();
  const result = [];
  const visit = (category, depth) => {
    if (seen.has(category.id)) return;
    seen.add(category.id);
    result.push({ ...category, depth });
    categories.filter(child => child.parentId === category.id).forEach(child => visit(child, depth + 1));
  };
  categories.filter(category => !byId.has(category.parentId)).forEach(category => visit(category, 0));
  categories.forEach(category => visit(category, 0));
  return result;
}
